import _ from 'lodash';
import React, { Component } from 'react';
import MoneyComponent from './MoneyComponent';
import Category from '../../models/Category';

export default class TransactionMoneyComponent extends Component {

	render() {
		const { categories, categoryId, amount, ...otherProps } = this.props;
		const category = categories && categories.get(categoryId);

		const categoryGroup = category ? category._getCategoryGroup() : null;

		let amountValue = amount;
		if(_.isString(amount)) {
			amountValue = amount.replace('$', '').replace(',', '');
		}

		const isExpenseGroup = !categoryGroup || categoryGroup.isExpenseCategoryGroup();

		const isIncomeGroup = categoryGroup && categoryGroup.isIncomeCategoryGroup();
		const isPositive = (isExpenseGroup && amountValue < 0) || (isIncomeGroup && amountValue > 0);
		const isNegative = (isExpenseGroup && amountValue > 0) || (isIncomeGroup && amountValue < 0);

		const shouldFlipSign = isExpenseGroup && amountValue < 0;

		return (
			<MoneyComponent
				showPlus={shouldFlipSign}
				showPositive={isPositive}
				showNegative={isNegative}
				amount={shouldFlipSign ? amountValue * -1 : amountValue}
				{...otherProps}
			/>
		);
	}
}